import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Package, FileText, Laptop, Target, Mic } from 'lucide-react';

const modules = [
  {
    week: 1,
    title: 'Introduction to Export',
    icon: Globe,
    description: 'Understanding global trade fundamentals and export opportunities',
    color: 'blue'
  },
  {
    week: 2,
    title: 'Product & Market Discovery',
    icon: Package,
    description: 'Identifying exportable products and target markets',
    color: 'green'
  },
  {
    week: 3,
    title: 'Documentation & Compliance',
    icon: FileText,
    description: 'Essential export documents and regulatory requirements',
    color: 'purple'
  },
  {
    week: 4,
    title: 'Digital Export Tools',
    icon: Laptop,
    description: 'Leveraging technology for export operations',
    color: 'orange'
  },
  {
    week: 5,
    title: 'Export Simulation',
    icon: Target,
    description: 'Hands-on practice with real export scenarios',
    color: 'red'
  },
  {
    week: 6,
    title: 'Campus Clinics',
    icon: Mic,
    description: 'Interactive sessions and Q&A with export experts',
    color: 'indigo'
  }
];

const C2CCurriculum = () => {
  return (
    <section id="curriculum" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl font-bold text-gray-900 sm:text-4xl"
          >
            What You'll Learn
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="mt-4 text-xl text-gray-600 max-w-2xl mx-auto"
          >
            6 weeks of comprehensive export training designed for students
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {modules.map((module, index) => (
            <motion.div
              key={module.week}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="relative bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group"
            >
              <div className={`absolute top-0 left-0 w-full h-1 bg-${module.color}-500`} />
              
              <div className="p-8">
                <div className={`w-16 h-16 bg-${module.color}-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <module.icon className={`h-8 w-8 text-${module.color}-600`} />
                </div>
                
                <div className="flex items-center mb-4">
                  <span className={`text-sm font-bold text-${module.color}-600 bg-${module.color}-100 px-3 py-1 rounded-full`}>
                    Week {module.week}
                  </span>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {module.title}
                </h3>
                
                <p className="text-gray-600">
                  {module.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default C2CCurriculum;